import { useEffect } from 'react';

export default function useDebounce(delay, fn, deps) {
  useEffect(() => {
    const timeout = setTimeout(fn, delay);
    return () => clearTimeout(timeout);
  }, deps);
}
